<ecp-hero title="Individual Order Review" image="assets/images/headers/experts.jpg"> </ecp-hero>

<div class="container bulk-review-page">
  <div class="col s12 is-flex is-fullwidth">
    <mat-card>
      <div class="order-review-page mt-5">
        <div class="row mt-10">
          <div class="col s4">
            <mat-form-field>
              <input matInput autoFocus placeholder="Search" (keyup)="applyFilter($event)" />
              <mat-hint></mat-hint>
            </mat-form-field>
          </div>
          <div class="col s4">
            <mat-form-field>
              <mat-select placeholder="Select Location" (selectionChange)="filterLocation($event)">
                <mat-option *ngFor="let ecpLoc of ecpLocations" [value]="ecpLoc">
                  {{ ecpLoc }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col s2">
            <div style="align-items: center;display: flex;">
              <input
                matInput
                [(ngModel)]="orderFrom"
                [matDatepicker]="picker1"
                [max]="orderTo"
                (dateChange)="getOrderListDate()"
              />
              <mat-datepicker #picker1></mat-datepicker>
              <mat-icon matSuffix (click)="picker1.open()">calendar_month</mat-icon>
            </div>
          </div>
          <div class="col s2">
            <div style="align-items: center;display: flex;">
              <input
                matInput
                [(ngModel)]="orderTo"
                [matDatepicker]="picker2"
                [min]="orderFrom"
                (dateChange)="getOrderListDate()"
              />
              <mat-datepicker #picker2></mat-datepicker>
              <mat-icon matSuffix (click)="picker2.open()">calendar_month</mat-icon>
            </div>
          </div>
        </div>
        <div class="row mt-15">
          <div class="col m2 offset-m10">
            <button class="btn btn-primary" (click)="downloadOrders()">Download</button>
          </div>
        </div>
        <table mat-table [dataSource]="bulkOrderData" class="mt-50 is-fullwidth" matSort>
          <!-- fdAccountNumber Column -->
          <ng-container matColumnDef="fdAccountNumber">
            <th class="w-10" mat-header-cell *matHeaderCellDef mat-sort-header>Account Number</th>
            <td mat-cell *matCellDef="let element">{{ element.fdAccountNumber }}</td>
          </ng-container>
          <!-- UPC Column -->
          <ng-container matColumnDef="upc">
            <th class="w-10" mat-header-cell *matHeaderCellDef mat-sort-header>UPC</th>
            <td mat-cell *matCellDef="let element">{{ element.upc }}</td>
          </ng-container>
          <!-- Job Type Column -->
          <ng-container matColumnDef="patientName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Patient Name</th>
            <td mat-cell *matCellDef="let element">{{ element.patientName }}</td>
          </ng-container>
          <ng-container matColumnDef="rxOrderId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>RX Order Id</th>
            <td mat-cell *matCellDef="let element">{{ element.rxOrderId }}</td>
          </ng-container>
          <ng-container matColumnDef="poNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>PO Number</th>
            <td mat-cell *matCellDef="let element">{{ element.poNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="uploadedBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload By</th>
            <td mat-cell *matCellDef="let element">{{ element.uploadedBy }}</td>
          </ng-container>
          <ng-container matColumnDef="processedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Processed On</th>
            <td mat-cell *matCellDef="let element">{{ parseProcessDate(element.processedOn) | date: 'MM/dd/yyyy' }}</td>
          </ng-container>
          <ng-container matColumnDef="frameStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Frame Status</th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.frameStatus; else statusPending">
                <span class="has-success">{{ element.frameStatus }}</span>
              </ng-container>
              <ng-template #statusPending>
                <span class="has-warning">Submitted</span>
              </ng-template>
            </td>
          </ng-container>
          <ng-container matColumnDef="frameStatusDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Latest Frame Status Date</th>
            <td mat-cell *matCellDef="let element">
              {{ parseProcessDate(element.frameStatusDate) | date: 'MM/dd/yyyy' }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="bulkOrderColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: bulkOrderColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons> </mat-paginator>
        <mat-card *ngIf="showNoResult" class="text-center disabled">No records found</mat-card>
      </div>
    </mat-card>
  </div>
</div>
